import React from 'react';

//Internal modules
import {
  GenericSubmission,
  PasswordlessForcedSignupSubmission,
} from '../../../FormSubmission';
import { weasleyFlowType } from '../constants';
import { SignupFields } from '@/components/SignupFields';
import { Section } from '@/components/Form/StyledComponents';
// @ts-expect-error untyped import
import { StreamlineSectionHeader } from '../../../Components';
import { ContactFieldsSection } from '@/components/ContactInformation';
import { StreamlineOnboardOptions } from '@/components/OnboardOptions/StreamlineOnboardOptions';

interface StreamlineProps {
  enableSilentDisclaimer?: boolean;
  flowType: string;
}

export const Streamline = ({
  flowType,
  enableSilentDisclaimer = false,
}: StreamlineProps): React.ReactElement => {
  if (flowType === weasleyFlowType.FORCED_PASSWORDLESS_FLOW) {
    return (
      <>
        <Section data-testid="forced-passwordless-flow">
          <StreamlineSectionHeader
            enableSilentDisclaimer={enableSilentDisclaimer}
          />
          <Section>
            <ContactFieldsSection
              isStreamlineExperience
              mb="gutter"
              showHeading={false}
            />
            <SignupFields isPasswordless isStreamlineExperience />
          </Section>
        </Section>
        <PasswordlessForcedSignupSubmission showHeader={false} />
      </>
    );
  }

  if (flowType === weasleyFlowType.FORCED_WITH_PASSWORD_FLOW) {
    return (
      <>
        <Section data-testid="forced-with-password-flow">
          <StreamlineSectionHeader />
          {/*TS conversion PR, so avoiding changing prod code for now
          @ts-expect-error - this is not a prop, why are we passing it? */}
          <Section as="div">
            <ContactFieldsSection
              isStreamlineExperience
              mb="gutter"
              showHeading={false}
            />
            <SignupFields isStreamlineExperience />
          </Section>
        </Section>
        <GenericSubmission />
      </>
    );
  }

  return (
    <>
      <Section data-testid="optional-with-password-flow">
        <ContactFieldsSection isStreamlineExperience />
        <StreamlineOnboardOptions />
      </Section>
      <GenericSubmission />
    </>
  );
};
